export const getContributionHoursText = (hours: number): string => `${hours} Hour${hours > 1 ? 's' : ''}/Week`;
